import { useState } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import cn from 'classnames'
import { ArrowListExpand } from '@/utils/icons'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import AccessLevelControl from '../AccessLevelControl/AccessLevelControl'
import {
  getAccessActionKey,
  getAggregateAccessControl,
} from '../../utils/access'
import { AccessColumn, BlockRowProps, IconComponent } from '../../utils/types'
import styles from '../../index.module.css'

const CloseIcon = CloseOutlined as unknown as IconComponent

const BlockRow = ({
  block,
  children,
  accessDisabled,
  pendingActionKey,
  onAccessChange,
  onReset,
}: BlockRowProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const renderAccessControl = (column: AccessColumn) => {
    const value = getAggregateAccessControl(block.access_summary, column)
    const actionKey = getAccessActionKey('block', block.id, column)
    const tooltip =
      column === 'materials'
        ? 'Открыть / закрыть материалы всех уроков блока'
        : 'Открыть / закрыть выполнение заданий во всех уроках блока'

    return (
      <AccessLevelControl
        state={value.state}
        disabled={value.disabled || accessDisabled}
        loading={pendingActionKey === actionKey}
        tooltip={tooltip}
        ariaLabel={tooltip}
        onClick={() =>
          onAccessChange({
            entityType: 'block',
            entityId: block.id,
            entityName: block.name,
            column,
            state: value.state,
          })
        }
      />
    )
  }

  return (
    <>
      <div
        className={styles.row}
        onClick={() => setIsOpen((value) => !value)}
      >
        <div className={cn(styles.cell, styles.blockCell, styles.groupCell)}>
          {block.name}
          <span
            className={cn(styles.expandIcon, isOpen && styles.expandIconOpen)}
          >
            <ArrowListExpand />
          </span>
        </div>
        {renderAccessControl('materials')}
        {renderAccessControl('tasks')}
        <TooltipWrapper title="Сбросить прогресс блока" placement="top">
          <button
            type="button"
            className={styles.resetButton}
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              onReset()
            }}
          >
            <CloseIcon />
          </button>
        </TooltipWrapper>
      </div>
      {isOpen && children}
    </>
  )
}

export default BlockRow
